import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import './theme/theme.css';
import './theme/majlis.css';
import App from './App';
import PublicIrabPage from './components/PublicIrabPage';
import PublicSarfPage from './components/PublicSarfPage';
import PublicTypingPage from './components/PublicTypingPage';
import PublicReaderPage from './components/PublicReaderPage';
import PublicTopicPage from './components/public/PublicTopicPage';
import ExtensionConnectPage from './components/ExtensionConnectPage';
import AppConnectPage from './components/AppConnectPage';
import OnboardingPage from './components/onboarding/OnboardingPage';
import reportWebVitals from './reportWebVitals';
import { initAnalytics } from './utils/analytics';
import { captureAttribution } from './utils/attribution';

// Module top-level so it runs exactly once (StrictMode double-mounts effects,
// not modules). No-op unless REACT_APP_UMAMI_WEBSITE_ID was set at build time.
initAnalytics();
// First-touch utm_* capture on every entry route — the tracker strips query
// strings, so this localStorage stage is the only place UTMs survive.
captureAttribution();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* /irab is the app's only PUBLIC route (no login) — mounted here so
        App (and its auth gate + URL-param handling) never runs on it.
        Everything else renders through App: /majlis is the first real
        route; the rest lives under App's internal catch-all. */}
    <BrowserRouter>
      <Routes>
        <Route path="/irab" element={<PublicIrabPage />} />
        {/* /sarf is public like /irab — the Verb Conjugator. */}
        <Route path="/sarf" element={<PublicSarfPage />} />
        {/* /typing is public like /irab — the Arabic typing tutor. */}
        <Route path="/typing" element={<PublicTypingPage />} />
        {/* /reader is public like /irab — the PDF reader (local-only files). */}
        <Route path="/reader" element={<PublicReaderPage />} />
        {/* /extension-connect links the Chrome extension to the signed-in
            account (one-click token handoff to its content script). */}
        <Route path="/extension-connect" element={<ExtensionConnectPage />} />
        {/* /app-connect does the same for the macOS app, via a single-use code
            and the murajairab:// URL scheme (a native app can't postMessage). */}
        <Route path="/app-connect" element={<AppConnectPage />} />
        {/* /start is the social-media onboarding funnel — public like /irab. */}
        <Route path="/start" element={<OnboardingPage />} />
        {/* /t/<token> is an admin-shared topic, viewable without an account. */}
        <Route path="/t/:token" element={<PublicTopicPage />} />
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
    {/* Rotate-to-landscape lock — only shows on tablets held in portrait
        (see .rotate-lock in theme.css). Phones and desktops are unaffected. */}
    <div className="rotate-lock" role="alertdialog" aria-label="Rotate your device to landscape">
      <div className="rotate-lock__inner">
        <svg className="rotate-lock__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
          <rect x="7" y="2" width="10" height="20" rx="2" />
          <line x1="10.5" y1="18.5" x2="13.5" y2="18.5" />
        </svg>
        <h2 className="rotate-lock__title">Rotate to landscape</h2>
        <p className="rotate-lock__text">Murājaʿa is best used in landscape on a tablet. Please turn your device.</p>
      </div>
    </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
